module.exports = __webpack_public_path__ + "static/media/icon_system_social_instagram.0605dfa5.svg";